import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../pages/css components/Button";
import Paper from "./Paper";
import { useDispatch } from "react-redux";
import { alert } from "../redux/slices/alertSlice";

export default function ButtonFooter({
  ID = "",
  disabled = false,
  editState,
  setEditState,
  formikProps,
  route = "",
  deleteButton = [],
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogState, setDialogState] = useState(false);

  const [deletePermission, handleDelete, buttonLabel = "Delete"] = deleteButton;

  if (!(deletePermission || (!!editState && !!setEditState && !!formikProps))) {
    return "";
  }

  const handleSubmitClick = async () => {
    const errors = await formikProps.validateForm();
    let prefix = "";
    let missing = flattenErrorsWithValue(errors, (prefix = ""));

    formikProps.setTouched(missing);
    if (Object.keys(errors).length > 0) {
      dispatch(
        alert({
          message:
            "Some fields are invalid or incomplete. Kindly correct them to proceed.",
          type: "error",
        })
      );
      return;
    }

    formikProps.handleSubmit();
  };

  return (
    <Paper>
      {!!deletePermission && !!ID && (
        <Grid size>
          <Button
            variant="contained"
            color="error"
            onClick={() => setDialogState(true)}
          >
            {buttonLabel}
          </Button>
        </Grid>
      )}

      <Grid size="auto" offset={{ md: "auto" }} />

      {!editState && (
        <Grid size>
          <CancelButton variant="outlined" onClick={() => navigate(-1)}>
            Back
          </CancelButton>
        </Grid>
      )}

      {!!editState && (
        <Grid size>
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            fullWidth
            onClick={handleSubmitClick || formikProps.handleSubmit}
            disabled={formikProps.isSubmitting}
            loading={formikProps.isSubmitting}
            color="primary"
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      )}

      {!!editState && (
        <Grid size>
          <CancelButton
            variant="outlined"
            disabled={formikProps.isSubmitting}
            onClick={() => {
              if (editState && !!ID) {
                setEditState(!editState);
                return;
              }
              if (!!route) {
                navigate(-1, { state: route });
              } else {
                navigate(-1);
              }
            }}
          >
            Cancel
          </CancelButton>
        </Grid>
      )}

      <DeleteDialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        handleAgree={handleDelete}
      />
    </Paper>
  );

  function flattenErrorsWithValue(obj, prefix = "") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;

      if (value && typeof value === "object" && !Array.isArray(value)) {
        if (
          "value" in value &&
          typeof value.value === "object" &&
          !Array.isArray(value.value)
        ) {
          Object.assign(
            acc,
            flattenErrorsWithValue(value.value, `${newKey}.value`)
          );
        } else if ("value" in value) {
          acc[`${newKey}.value`] = true;
        } else {
          Object.assign(acc, flattenErrorsWithValue(value, newKey));
        }
      } else {
        acc[newKey] = true;
      }

      return acc;
    }, {});
  }
}

function DeleteDialog({ dialogState, setDialogState, handleAgree }) {
  return (
    <Dialog open={dialogState}>
      <DialogTitle style={{ paddingBottom: "4px" }}>Confirm Delete</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete? This action cannot be reversed!
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{ padding: "0px 24px 16px" }}>
        <Button
          onClick={() => {
            handleAgree();
            handleClose();
          }}
          variant="contained"
          color="error"
        >
          Delete
        </Button>

        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          autoFocus
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  function handleClose() {
    setDialogState(false);
  }
}
